import { render, staticRenderFns } from "./SmartOrder.vue?vue&type=template&id=1b5776e3&scoped=true&"
import script from "./SmartOrder.vue?vue&type=script&lang=js&"
export * from "./SmartOrder.vue?vue&type=script&lang=js&"
import style0 from "./SmartOrder.vue?vue&type=style&index=0&id=1b5776e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5776e3",
  null
  
)

export default component.exports